import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsSeriesManager } from "../managers/seriesManager";
import { KidsSeriesIcon } from "../model/SeriesIcon";
import { KidsUtil } from "../utils";
import { KidsBaseGridView } from "./BaseGridView";

/**
 * The main home screen contains the series icon layout.
 * tlc.ls2kids.views.SeriesView
 */
export class KidsSeriesView extends KidsBaseGridView {
	constructor() {
		super({
			baseTemplate: 'tmpl/kids/series/seriesView.html',
			id: LS2KIDS_CONSTANTS.Ids.seriesPage.main,
			targetId: LS2KIDS_CONSTANTS.Ids.mainContent,
			viewClass: 'baseView',

			scrollWrapperId: LS2KIDS_CONSTANTS.Ids.seriesPage.seriesScrollWrapper,
			listId: LS2KIDS_CONSTANTS.Ids.seriesPage.seriesList,
			itemConstructor: KidsSeriesIcon,

			_desiredFullCellHeight: 200,
			_desiredFullCellWidth: 150,

			_desiredIconRowMargin: 15,
			_desiredIconColMargin: 15,

			absoluteCenter: false,

			distributeMargin: 0,
			distributeSize: 1,

			distributeMarginEvenly: false,
			distributeSizeEvenly: false,

			analyticsTrackingName: "series"
		});


		this._addListeners();
	}
	
	/**
	 * When the view loads, we refresh the grid to be sure things are aligned properly.
	 *
	 * @override
	 */
	load() {
		super.load(arguments);

		TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onSeriesViewStarted);
	}
	/**
	 * Add all events to handle showing/hiding this view.
	 *
	 * @private
	 */
	_addListeners() {
		this.setShowEvent(LS2KIDS_CONSTANTS.Events.onStartSeriesView);

		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartCategoryView);
		this.setHideEvent(LS2PAC_CONSTANTS.Events.onSearch);
	}
	/****************************************************************************
	 * Grid
	 ****************************************************************************/
	/**
	 * Refresh the grid. Will guarantee it shows properly.
	 */
	refreshGrid() {
		super.refreshGrid(arguments);

		TLCEventManager.fireEvent(LS2KIDS_CONSTANTS.Events.onSeriesGridRefresh, {
			rows: this._rows,
			cols: this._columns
		});
	}
	_getItemById(seriesId) {
		return KidsSeriesManager.getSeries(seriesId);
	}
	_getLayout() {
		// 2 part function, first part is to create the groups between the two image styles.
		var seriesByImageTypes = KidsSeriesManager.getSpecialImagedSeries();

		// the loops will iterate over small logos or large logos, whichever is less. the main
		// loop is assumed it will loop small logos (STYLE_1). if it does flip, then while
		// making the group, it will have to be flipped before adding to array of available groups
		// if there are less jackets than there are logos, then we need to know that
		var flipped = false;

		// copy the 3 kinds of images we have for series
		var loopStyles = seriesByImageTypes.style1.slice(0);
		var otherStyles = seriesByImageTypes.style2.slice(0);
		var jackets = seriesByImageTypes.jackets.slice(0);

		// we loop over whichever we have less of, whether its style 1 or style 2,
		if (loopStyles.length > otherStyles.length) {
			loopStyles = seriesByImageTypes.style2;
			otherStyles = seriesByImageTypes.style1;
			flipped = true;
		}

		// start creating the groups
		var groups = [];

		while (loopStyles.length > 0) {
			// create the group
			var group = [
				{
					"type": flipped
						? KidsSeriesManager.imageTypes.STYLE_2
						: KidsSeriesManager.imageTypes.STYLE_1,
					"id": KidsUtil.puntRandom(loopStyles)
				},
				{
					"type": flipped
						? KidsSeriesManager.imageTypes.STYLE_1
						: KidsSeriesManager.imageTypes.STYLE_2,
					"id": KidsUtil.puntRandom(otherStyles)
				}
			];

			// if we flipped it, we have to flip the result
			if (flipped) {
				group.reverse();
			}

			groups.push(group);
		}

		// we have to now merge the group that more icons (if it was not flipped)
		var ordering = [];

		// if we flipped, then we use an empty array
		var secondaryCells = flipped ? [] : otherStyles;
		var mainCells = null;

		// loop the ones we have most of and then distribute the ones we have least of amongst the others
		// remember, if we flipped, we had more styles that we can't show alone so set an empty array
		if (jackets.length < secondaryCells) {
			mainCells = secondaryCells;
			secondaryCells = jackets;
		} else {
			mainCells = jackets;
		}

		// we need some counters, one for how many mainCells we've rendered, and the overall
		var mainCellRenderCount = 0;
		var cellRenderCount = 0;

		// distribute the number of main cells AND secondary cells per group
		var largeCellsForOneGroup = Math.ceil((mainCells.length + secondaryCells.length) / groups.length);

		// distribute the number of main cells there are per secondary cell
		var mainCellsForOneSecondaryCell = Math.ceil(mainCells.length / secondaryCells.length);

		// ok now lets go through all the main cells.
		while (mainCells.length > 0) {

			// check if we should display a group
			if (cellRenderCount % largeCellsForOneGroup == 0 && groups.length > 0) {
				var nextGroup = KidsUtil.puntRandom(groups);
				nextGroup[0].index = nextGroup[1].index = cellRenderCount;

				ordering = ordering.concat(nextGroup);
			} else {

				// check to see if we should display a secondary cell
				if (mainCellRenderCount % mainCellsForOneSecondaryCell == 0 && secondaryCells.length > 0) {
					var nextSecondary = KidsUtil.puntRandom(secondaryCells);

					ordering.push({
						"type": KidsSeriesManager.imageTypes.STYLE_JACKET,
						"id": nextSecondary,
						"index": cellRenderCount
					});
				} else {
					var nextMain = KidsUtil.puntRandom(mainCells);

					ordering.push({
						"type": KidsSeriesManager.imageTypes.STYLE_JACKET,
						"id": nextMain,
						"index": cellRenderCount
					});
				}

				mainCellRenderCount++;
			}

			cellRenderCount++;
		}

		return ordering;
	}
}







